import { httpClient } from "./httpClient";

const getAllJobPostingApply = () => {
  return httpClient.get("jobpostingapply");
};

export default {
  getAllJobPostingApply,
};
